export default __webpack_public_path__ + "static/media/fit-vertical.ae2ecbb8.svg";